/* eslint-disable radix */
/* eslint-disable react/no-array-index-key */
/* eslint-disable camelcase */
/* eslint-disable react/no-danger */
import React, { Component } from 'react';
// import { withRouter } from 'react-router-dom';
import Router from 'next/router';
import ModalVideo from 'react-modal-video';
import Img from '../../Img';
import config from '../../../config';
import TrackedCta from '../../Analytics/TrackedCTA';

import styles from './hero.module.scss';

const { appHost } = config;

class Hero extends Component {
    constructor() {
        super();
        this.state = {
            isOpen: false,
        };
        this.openModal = this.openModal.bind(this);
        this.prismicRedirect = this.prismicRedirect.bind(this);
        this.scrollTo = this.scrollTo.bind(this);
    }

    prismicRedirect(url) {
        if (url.startsWith('http')) {
            const win = window.open(url, '_blank');
            win.focus();
        } else if (url.startsWith('app:')) {
            // links pointing to the utr app
            window.location = url.replace('app:', appHost);
        } else if (url.startsWith('scrollTo')) {
            const scrollToValue = url.split(':');
            if (document.getElementById(scrollToValue[1]) !== null) {
                this.scrollTo(scrollToValue[1]);
            }
        } else if (url.startsWith('mailto')) {
            window.location = url;
        } else {
            // internal routing within marketing app
            Router.push(url);
        }
    }

    scrollTo(targetId) {
        // Scroll to a certain element
        document.getElementById(targetId)
            .scrollIntoView({
                behavior: 'smooth',
                alignToTop: true,
                block: 'nearest' });
    }

    openModal(video) {
        this.setState({ isOpen: video });
    }

    render() {
        // eslint-disable-next-line no-unused-vars
        const { heroImage, videoid, overlayPercent, maintitle, maintitlecolor, topline, authed, subtitlecolor, subtitle, primaryctacopy, sectiontitle, primaryctalink, secondaryctacopy, secondaryctalink, image_caption, secondaryisvideo, utrvideolinkcolor, secondaryisdefaultbtn } = this.props;
        const desktopBg = heroImage && heroImage.desktop;
        const mobileBg = heroImage && heroImage.mobile;
        const videoBg = heroImage && heroImage.video;
        const videoPoster = heroImage && heroImage.videoPoster;
        const captions = (heroImage && heroImage.captions) || [];
        const bgOpacity = overlayPercent ? `0.${100 - parseInt(overlayPercent)}` : '1';
        const bgImg = (imageObj) => {
            if (imageObj && imageObj.oneX && imageObj.twoX && imageObj.threeX) {
                return (
                    <Img
                        useRawSrcSet={true}
                        src={imageObj.oneX}
                        srcSet={`${imageObj.twoX} 2x, ${imageObj.threeX} 3x`}
                        style={{ left: '0%' }}
                    />
                );
            } if (imageObj && imageObj.default) {
                return (
                    <Img
                        src={imageObj.default}
                        style={{ left: '0%' }}
                    />
                );
            }
            return null;
        };


        return (
            <div className="position-relative">
                <ModalVideo channel="youtube" isOpen={this.state.isOpen === 'video1'} videoId={videoid} autoplay={true} onClose={() => this.setState({ isOpen: false })} />
                <div className="p-rel">
                    <div className="container">
                        <div className={`${styles.hero} ${authed ? 'authed' : ''}`}>
                            <div className="row">
                                <div className="col-sm-10 offset-sm-1 col-md-12 offset-md-0 ">
                                    <div className={styles.heroContent}>
                                        <div className="text-highlight1 text-highlight-green fs13">
                                            {topline}
                                        </div>
                                        <h1 className={`text-white ${styles.title}`} dangerouslySetInnerHTML={{ __html: maintitle }} />
                                        <div className={`text-medium ${styles.heroText}`} style={{ color: subtitlecolor }} dangerouslySetInnerHTML={{ __html: subtitle }} />
                                        {primaryctacopy && primaryctalink && (
                                            <TrackedCta
                                                eventName="Join Clicked"
                                                traits={{
                                                    pageLocation: 'hero',
                                                    uxType: 'button',
                                                    content: primaryctacopy,
                                                    context: sectiontitle,
                                                }}
                                            >
                                                <div
                                                    className={`btn btn-primary btn-lg text-white ${styles.joinBtn} text-uppercase`}
                                                    onClick={() => {
                                                        this.prismicRedirect(primaryctalink);
                                                    }}
                                                >
                                                    {primaryctacopy}
                                                </div>
                                            </TrackedCta>
                                        )}
                                        {secondaryctacopy && (
                                            <div
                                                className={`btn ${secondaryisdefaultbtn ? 'btn-default' : 'btn-primary'} btn-lg btn-hero text-white ${styles.joinBtn} text-uppercase`}
                                                onClick={() => {
                                                    if (secondaryctalink) {
                                                        this.prismicRedirect(secondaryctalink);
                                                    } else if (secondaryisvideo) {
                                                        this.openModal('video1');
                                                    }
                                                }}
                                            >
                                                {secondaryctacopy}
                                            </div>
                                        )}
                                        <div className={`${styles.heroLinkWrapper}`}>
                                            {/* <div
                                                className={`${styles.heroLink} ${styles.br} ${styles.hasIcon}`}
                                                style={{ color: utrvideolinkcolor, borderColor: utrvideolinkcolor }}
                                                onClick={() => {
                                                    this.openModal('video1');
                                                }}
                                            > <i className={styles.videoPlay} /> What is utr?
                                            </div>
                                            <a
                                                className={`${styles.heroLink}`}
                                                style={{ color: utrvideolinkcolor }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    window.location.href = e.target.href;
                                                }}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                href="https://blog.universaltennis.com/2018/07/03/how-utr-works/"
                                            >How it works
                                            </a> */}
                                        </div>
                                        {primaryctalink && primaryctacopy && (
                                            <div className={`d-block mt16 ${styles.heroLink}`}>
                                                <a
                                                    className={`fs14`}
                                                    style={{ color: utrvideolinkcolor, opacity: 0.7 }}
                                                    href={`${appHost}/login`}
                                                >
                                                    Already using UTR? <span className="fixed-underline clickable">Sign in</span>
                                                </a>
                                            </div>
                                        )}
                                        {/* <div className={`${styles.cta}`}> */}
                                        {/* <div className={`${styles.ctaText}`}>UTR Community Platform Launching Fall 2018</div> */}
                                        {/* <a className={`btn btn-primary btn-xl ${styles.joinBtn}`} onClick={this.scrollTo} href="">GET EARLY ACCESS</a> */}
                                        {/* </div> */}
                                        <div className={styles.caption}>
                                            <p className="text-small">
                                                {captions.map((caption, i) => {
                                                    if (caption && caption.trim() !== '') {
                                                        return (
                                                            <React.Fragment
                                                                key={`caption-${i}`}
                                                            >
                                                                {caption.trim()}
                                                                {(captions.length > 0 && captions.length - 1 !== i) && (
                                                                    <br />
                                                                )}
                                                            </React.Fragment>
                                                        );
                                                    }
                                                    return null;
                                                })}
                                            </p>
                                        </div>
                                    </div>
                                    {image_caption && (
                                        <div
                                            className={`text-white ${styles.heroCaption}`}
                                        >
                                            {image_caption}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.backgroundWrapper} ${this.props.authed ? 'authed' : ''}`}>
                        {!!desktopBg && (
                            <picture className={`${styles.img} d-none d-sm-block`} style={{ opacity: bgOpacity }}>
                                {bgImg(desktopBg)}
                            </picture>
                        )}
                        {!!mobileBg && (
                            <picture className={`${styles.img} d-block d-sm-none`} style={{ opacity: bgOpacity }}>
                                {bgImg(mobileBg)}
                            </picture>
                        )}
                        {!!videoBg && (
                            <video autoPlay loop muted playsInline role="presentation" className={`${styles.video}`} poster={videoPoster || ''}>
                                <source src={videoBg} type="video/mp4" />
                            </video>
                        )}
                        <div className={styles.backgroundOverlay} />
                    </div>
                </div>
            </div>
        );
    }
}

export default Hero;
